import { ApiState } from "@/store/general.types";
import { mutate } from "@/store/plugins/mutation-handler";
import { MutationTree } from "vuex";
import { ExcludedReason, ExcludedReasonState } from "./excluded-reason.types";

export const excludedReasonMutations: MutationTree<ExcludedReasonState> = {
    GET_EXCLUDED_REASONS_MUTATION(state: ExcludedReasonState, newState: ApiState<ExcludedReason>) {
        mutate(state, newState, 'getExcludedReasons');
    }
}
